module.exports = __webpack_public_path__ + "i18n/languages.da0ed43.json";